import { FullscreenExitOutlined, FullscreenOutlined, RadiusUpleftOutlined, UndoOutlined } from "@ant-design/icons";
import { Avatar, Button, Popover, TooltipProps } from "antd";
import { FC, useState } from "react";
import { LuBotMessageSquare } from "react-icons/lu";
import { Label } from "src/data/Label";
import { AIChat } from "../AIChat";
import useAiChatPopoverResize, { AI_CHAT_DEFAULT_HEIGHT, AI_CHAT_DEFAULT_WIDTH } from "./useAiChatPopoverResize";

const AIChatPopover: FC = () => {
  const [open, setOpen] = useState(false);
  const [enlarged, setEnlarged] = useState(false);

  const { popoverRef, hasMoved, resetSizeToDefault, onResizeStart } = useAiChatPopoverResize()

  const onXbotOpenChange: TooltipProps['onOpenChange'] = (visible) => {
    setOpen(visible);
  }

  const switchEnlarged = () => {
    setEnlarged(prev => !prev);
  }

  return <Popover overlayClassName={`xm-chat-popover ${enlarged ? 'xm-chat-popover-enlarged' : ''}`}
    overlayStyle={{
      transition: 'none',
    }}
    content={<div className="ai-chat-wrapper" ref={popoverRef} style={{
      width: AI_CHAT_DEFAULT_WIDTH,
      height: AI_CHAT_DEFAULT_HEIGHT
    }}><AIChat open={open} /></div>} open={open} onOpenChange={onXbotOpenChange}
    title={<div className="xm-chat-header">
      <div className="title">
        {!enlarged && <RadiusUpleftOutlined onMouseDown={onResizeStart} style={{ cursor: 'grab' }} title="Resize chat popover" />}
        <span className="flex">{Label.XORBOT}</span>
      </div>
      <div>
        {hasMoved && !enlarged && <Button type="text" size="small" onClick={resetSizeToDefault}><UndoOutlined title="Restore chat popover size to default" /></Button>}
        <Button type="text" size="small" onClick={switchEnlarged}>{enlarged ? <FullscreenExitOutlined title="Restore chat popover" /> : <FullscreenOutlined title="Enlarge chat popover" />}</Button>
      </div>
    </div>}
    trigger="click" placement="topRight">
    <Avatar className="xm-chat-icon" size={44} icon={<LuBotMessageSquare />} alt="Ask AI assistant" />
  </Popover>
}

export default AIChatPopover;